import { render, staticRenderFns } from "./CompetenciaPage.vue?vue&type=template&id=0feb759e&scoped=true&"
import script from "./CompetenciaPage.vue?vue&type=script&lang=js&"
export * from "./CompetenciaPage.vue?vue&type=script&lang=js&"
import style0 from "./CompetenciaPage.vue?vue&type=style&index=0&id=0feb759e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feb759e",
  null
  
)

export default component.exports